import React, { createContext, useState, useContext } from 'react';

const AnimationContext = createContext();

export const useAnimation = () => {
  const context = useContext(AnimationContext);
  if (!context) {
    throw new Error('useAnimation must be used within an AnimationProvider');
  }
  return context;
};

export const AnimationProvider = ({ children }) => {
  const [animationEnabled, setAnimationEnabled] = useState(true);

  return (
    <AnimationContext.Provider value={{ animationEnabled, setAnimationEnabled }}>
      {children}
    </AnimationContext.Provider>
  );
};
